import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom';
import { locations } from 'services/routes/locations';
import { getSong } from 'services/store/songs/actions';
import { StoreRootState } from 'services/store/types';

/**
 * This component is only rendered when someone tries to access to old url for song details.
 * We have to load the song name to be able to redirect to the correct new url.
 *
 * @example Url to test the redirect /music/details/e007a2de-3c9e-11ec-af9c-022ed69f96e6
 */
export const SongDetailsRedirect = () => {
  const { id: songId } = useParams<{ id: string }>();

  const dispatch = useDispatch();

  useEffect(() => {
    if (!songId) return;

    dispatch(getSong({ songId }));
  }, [dispatch, songId]);

  const song = useSelector(
    // @ts-ignore
    (state: StoreRootState) => state.songs.songs[songId]
  );

  if (!song?.title) return <></>;

  return (
    <Navigate
      to={locations.general.songDetails.pathname(
        // @ts-ignore
        songId,
        song.title
      )}
    />
  );
};
